import { render, staticRenderFns } from "./brand-portal.vue?vue&type=template&id=a0404ce2"
import script from "./brand-portal.vue?vue&type=script&lang=ts"
export * from "./brand-portal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports